
export class NeedleSizesSharedDto {
    id: number;
     needleSizes: string;
     createdUser?: string;
     isActive?: boolean
     versionFlag?: number;
     updatedUser?: string;
     updatedAt?: Date;
 
     constructor(id: number, needleSizes: string,
     createdUser?: string, isActive?: boolean, versionFlag?: number, updatedUser?: string,
         updatedAt?: Date) {
         this.id =id;
         this.needleSizes = needleSizes
         this.createdUser = createdUser;
         this.isActive = isActive;
         this.versionFlag = versionFlag;
         this.updatedUser = updatedUser;
         this.updatedAt = updatedAt;
 
     }
 }
 